import React, {useRef, useState, useEffect} from 'react'
import * as tools from '../../Utils/tools'
import {icon_edit} from '../../assets/icons/icon-svg'

const Input = ({
  data,
  placeholder,
  error,
  label,
  externalLabel,
  id,
  showPass,
  doChange,
  type,
  codeArea,
  defaultValue,
  showIconEdit,
  ...props
}) => {
  const [viewPass, setViewPass] = useState(false)
  const [labelActive, setLabelActive] = useState(false)
  const [currentValue, setCurrentValue] = useState('')

  const inputRef = useRef(null)

  useEffect(() => {
    if (inputRef?.current?.value.length > 0) {
      setLabelActive(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputRef?.current?.value])

  useEffect(() => {
    setCurrentValue(defaultValue || '')
    if (!defaultValue) {
      setLabelActive(false)
    } else {
      setLabelActive(true)
    }
  }, [defaultValue])

  useEffect(() => {
    if (![null, undefined].includes(inputRef.current.value)) {
      if (inputRef.current.value.length > 0) {
        setLabelActive(true)
      } else {
        setLabelActive(false)
      }
    } else {
      setLabelActive(false)
    }
  }, [inputRef])

  function ViewPassFn() {
    setViewPass((prevState) => !prevState)
  }

  function changeValue(el) {
    setCurrentValue(el.target.value)
    if (doChange) {
      doChange(el.target.value)
    }
  }

  return (
    <>
      <div className="input-yapp">
        <div className="content-input-bg">
          {externalLabel && (
            <label className="txt-3--bold m-0 mb-2" htmlFor={id}>
              {label}
            </label>
          )}
          <div className="position-relative">
            <input
              id={id}
              ref={inputRef}
              type={showPass ? (!viewPass ? 'password' : 'text') : 'text'}
              className={`input-custom-secondary font-regular w-100 ${
                label && (externalLabel ? '' : 'input-label-center')
              }`}
              style={type === 'tel' && codeArea ? {paddingLeft: '45px'} : {}}
              placeholder={externalLabel ? placeholder : ''}
              value={currentValue}
              onChange={changeValue}
              codeArea={codeArea}
              {...props}
            />
            {codeArea && (
              <span
                className={
                  'txt-5--regular' +
                  (externalLabel ? ' tel-codearea-light' : ' tel-codearea')
                }>
                {codeArea}
              </span>
            )}
          </div>
          {externalLabel
            ? null
            : label && (
                <label
                  className={`label ${labelActive && 'active'} ${
                    codeArea && 'active'
                  }`}
                  htmlFor={id}>
                  {labelActive ? label : placeholder ? placeholder : label}
                </label>
              )}
          {showPass && (
            <span
              className="view-pass c-pointer z-index-99"
              onClick={() => ViewPassFn()}>
              {' '}
              <i
                className={
                  viewPass ? 'icon-eye-on ' : 'icon-eye-on color-gray-4'
                }
              />
            </span>
          )}
          {showIconEdit && (
            <div className="input-icon-right">
              <span className="color-theme icon-edit-datepiker">
                {icon_edit}
              </span>
            </div>
          )}
        </div>
        {error && (
          <p className="txt-6--regular-er mt-1 mb-2">{error.message}</p>
        )}
      </div>
    </>
  )
}

export default Input
